module.exports = __webpack_public_path__ + "img/VPN-alt.14dbd8ec.svg";